export default {"src":"/_next/static/media/CancleV.300e22f4.svg","height":24,"width":24};